export class WbParticipants {

  init() {
    return new Promise((resolve) => {
      document.querySelector('body')._addCustomEventListener('submit', 'form#ticket-details', this.submitForm.bind(this));
      resolve();
    });
  }

  submitForm(e) {
    if(! this.validate()) {
      e.preventDefault();
    }
  }

  validate() {
    const entries = document.querySelectorAll('.wb-checkout__ticket');
    const elements = [];
    this.clearErrors(entries);

    entries.forEach((entry) => {
      const data = {
        firstname: entry.querySelector('input[data-name="firstname"]'),
        lastname: entry.querySelector('input[data-name="lastname"]'),
        email: entry.querySelector('input[data-name="email"]'),
        company: entry.querySelector('input[data-name="company"]'),
        error: false
      };

      if (! this.isEmpty(data) && ! this.isValid(data)) {
        this.displayErrors(data);
        data.error = true;
      }

      elements.push(data);
    });

    return ! Object.values(elements).some((element) => element.error);
  }

  isEmpty(data) {
    return data.firstname.value === '' && data.lastname.value === '' && data.email.value === '' && data.company.value === '';
  }

  isValid(data) {
    return ! Object.values(data).some((property) => property.value === '');
  }

  displayErrors(data) {

    for (const property in data) {
      const input = data[property];

      if (input.value === null || input.value === '') {
        input.querySelector('.fui-error-message')?.remove();

        let error = document.createElement('div');
        error.classList.add('fui-error-message');
        error.textContent = `${input.placeholder} est obligatoire`;

        input.after(error);
      }
    }
  }

  clearErrors(entries) {
    entries.forEach((entry) => {
       entry.querySelectorAll('.fui-error-message').forEach((item) => item.remove());
    });
  }
}